import { chunk } from 'lodash'
import * as Yup from 'yup'
import { setProgress } from 'features/export_import/importExportSlice'
import { LIMITED_NUMBER_OF_UPLOADED_ITEMS } from 'features/export_import/utils'
import { showErrorNotification } from 'features/notifications/notificationsSlice'
// @ts-ignore
import SampleFile from 'features/export_import/sample_files/sample_meeting_participants.xlsx'
import { ImportDataFormProps, MappedField, SampleDataType } from 'features/export_import/types'
import { validation } from 'utils'
import { importMeetingParticipants } from '../graphql/mutation'

export const mappedFields: MappedField[] = [
    {
        field: 'externalId',
        label: 'ID',
        isRequired: true,
    },
    {
        field: 'email',
        label: 'Email',
        isRequired: true,
    },
    {
        field: 'role',
        label: 'Role',
        isRequired: true,
    },
]

export const sampleData: SampleDataType[] = [
    { header: 'ID', value: 'Unique ID' },
    { header: 'email', value: 'example@email.com' },
    { header: 'Role', value: 'primary_speaker / speaker / moderator / audience' },
]

export const validationSchema = Yup.array().of(
    Yup.object().shape({
        externalId: validation.excelExternalId,
        email: Yup.string().email().required(),
        role: Yup.string().oneOf(['primary_speaker', 'speaker', 'moderator', 'audience']).required(),
    })
)

export const importProps: Omit<ImportDataFormProps, 'onSubmit'> = {
    mappedFields,
    sampleData,
    sampleFile: SampleFile,
    validationSchema,
}

export const handleSubmit = async (meetingSpace, data, dispatch, callback) => {
    let completed = 0
    let errorItems = []
    const chunked_data = chunk(data, LIMITED_NUMBER_OF_UPLOADED_ITEMS)
    // eslint-disable-next-line no-restricted-syntax
    for (const _data of chunked_data) {
        // eslint-disable-next-line no-await-in-loop
        const response = await importMeetingParticipants({ meetingSpace, data: _data })
        if (response.errors.length) {
            return dispatch(showErrorNotification(response.errors))
        }
        const importResult = response.data.importMeetingParticipants
        completed += LIMITED_NUMBER_OF_UPLOADED_ITEMS
        errorItems = [...errorItems, ...importResult.errorItems.map((e) => e.id)]
        dispatch(
            setProgress({
                completed: Math.min(completed, data.length),
                errorItems,
            })
        )
    }
    callback?.()
}
